import { TagType } from 'constants/TagTypes';
import { dashboard } from 'types';
import { map, some } from 'es-toolkit/compat';
import { oc } from 'ts-optchain';

export function putTypeOnTags(
  tags: string[] | undefined,
  tagType: TagType
): Array<{ type: TagType; val: string }> {
  if (!tags) {
    return [];
  }
  return map(tags, (tagVal: string) => {
    return {
      type: tagType,
      val: tagVal,
      isToggle: false,
    };
  });
}

/**
 * isPriority for a type of tag (GUEST, VISIT) if there is at least one tag with an icon for that type.
 * @param {Array} tags The tags
 * @param {String} tagType the tag type
 * @param {Dictionary} priorityTags The global list of tags with icons across types
 * @returns {boolean} whether any tag in tags have an icon
 */
export function isPriority(
  tags: string[],
  tagType: number,
  priorityTags: Dictionary<Dictionary<dashboard.Tag>>
): boolean {
  if (!priorityTags || !tags) {
    return false;
  }

  return some(tags, (aTag) => {
    return !!oc(priorityTags)[tagType][aTag]();
  });
}

export function getTagsForProfile(profile: dashboard.IGuestProfile | undefined | null): string[] {
  if (!profile) {
    return [];
  }

  return profile.tag || [];
}

/**
 * Narrow a string to a valid tag type
 */
export const getTagTypeFromString = (type: string | null): dashboard.Tag.TagType | undefined => {
  if (type === 'GUEST' || type === 'VISIT') {
    return type;
  }

  return undefined;
};
